module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "info"
  }, [_c('mu-list', [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": require("./../../static/C.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$store.state.person.name))])]), _vm._v(" "), _c('mu-paper', {
    attrs: {
      "circle": ""
    }
  }), _vm._v(" "), _c('mu-paper', {
    staticClass: "bg"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$store.state.person.phone
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "call"
    },
    slot: "left"
  })], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "bg"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$store.state.person.email
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "email"
    },
    slot: "left"
  })], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "bg"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$store.state.person.profession
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "work"
    },
    slot: "left"
  })], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "bg"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$store.state.person.school
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "school"
    },
    slot: "left"
  })], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "bg"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$store.state.person.github,
      "href": _vm.$store.state.person.url,
      "target": "_blank"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "link"
    },
    slot: "left"
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-376b839a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personal.vue
// module id = 17
// module chunks = 0